import type { HealthCheckCategory } from './healthCheck.types'

export const RECENT_WINDOW_MS = 24 * 60 * 60 * 1000
export const COLLAPSED_VISIBLE_COUNT = 3
export const HIDDEN_DETAIL_FIELDS = ['id', 'workspace_id', 'ad_url', 'ad_id'] as const
export const CHANNEL_DETAIL_FIELD = 'marketing_channel'
export const HEALTH_CHECK_CATEGORIES = [
  'needs_attention',
  'suggestions',
  'dismissed',
  'other',
] as const satisfies readonly HealthCheckCategory[]
export const SUMMARY_CATEGORIES = ['needs_attention', 'suggestions'] as const
